export default __webpack_public_path__ + "assets/images/roulette-1e7134ad97e750175b66519635a065e8.svg";